var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const CaretLeft = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsxs("svg", Object.assign({ width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [_jsx("g", { clipPath: "url(#clip0)", children: _jsx("path", { d: "M5.85095 7.49477L5.85095 0.505203C5.85095 0.0597501 5.31238 -0.163333 4.9974 0.151649L1.50262 3.64643C1.30735 3.84169 1.30735 4.15828 1.50262 4.35354L4.9974 7.84832C5.31238 8.1633 5.85095 7.94022 5.85095 7.49477Z", fill: fill !== null && fill !== void 0 ? fill : COLORS.PURPLE[900] }) }), _jsx("defs", { children: _jsx("clipPath", { id: "clip0", children: _jsx("rect", { width: "8", height: "8", fill: "white", transform: "translate(8) rotate(90)" }) }) })] })));
};
